<template>
  <div id="app">
    <div v-if="!accessDenied" class="main-wrapper">
      <Loader :isVisible="isLoading" />
      <AlertPopup :callsData="calls" :importData="isMessage.message || {}" @dismiss-call-alert="removeCallAlert" />
      <ImportLoader :token="token"
        :isMessage="Object.values(isMessage).length ? isMessage : isImport ? isImport : {}" />
      <router-view />
    </div>
    <div v-else>
      <layouts-header></layouts-header>
      <layouts-sidebar></layouts-sidebar>
      <div class="text-center access-denied-container">
        <i class="fas fa-lock text-danger fa-5x mb-3"></i>
        <h2 class="text-danger">Access Denied</h2>
        <p class="text-muted">You do not have permission to view this page.</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Loader from '../src/views/layouts/index-loader.vue';
import AlertPopup from '../src/views/layouts/AlertPopup.vue';
import ImportLoader from '../src/views/layouts/Loader.vue';
import { connectSocket, disconnectSocket, joinRoom, onCallAlert, companyUserUpdated, onContractUpdated, onImportCompleted, onImportProgress } from './socket';
import showToast from '@/js/toast';
export default {
  components: { Loader, AlertPopup, ImportLoader },
  data() {
    return {};
  },
  computed: {
    ...mapState(["accessDenied"]),
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const isLoading = computed(() => store.state.isLoading);
    const isImport = ref(JSON.parse(localStorage.getItem('import')) || "");
    const isMessage = computed(() => store.state.importMessage);
    const calls = ref([]);
    const token = computed(() => store.getters['auth/isAuthenticated']);

    const userData = localStorage.getItem('user');

    const removeCallAlert = (index) => {
      if(index){
        calls.value.splice(index, 1);
      } else {
        calls.value = []
      }
    };

    watch(token, (newToken, oldToken) => {
      if (newToken) {
        connectSocket();
        joinRoom();

        onCallAlert((callData) => {
          // await store.dispatch('importMessage',{status:false,message:null})
          calls.value = [...calls.value, ...callData];
        });

        companyUserUpdated((permissionsData) => {
          if (userData) {
            let users = JSON.parse(userData);
            users.permissions = permissionsData?.permissions
            store.commit('auth/setUser', users)
            localStorage.setItem('user', JSON.stringify(users))
          }

        })

        onContractUpdated(async (contractData) => {
          showToast(contractData.message, 'info', {
               redirectUrl: `/crm/edit-contract/${contractData.contract_id}`,
               router
          })
          const params = {
          page: 1
        }
        await store.dispatch('users/fetchNotifications', params)
        });

        onImportCompleted(async (importDataValue) => {
        await store.dispatch('importMessage', { status: false, message: importDataValue })
        localStorage.setItem('import', JSON.stringify({ status: false, message: importDataValue }))
      });

      onImportProgress(async (progress) => {
        await store.dispatch('importMessage', { status: true, message: null, progress: progress })
        localStorage.setItem('import', JSON.stringify({ status: true, message: null, progress: progress }))
      });


      }
    }, { immediate: true });

    watch(calls, async (newMessage) => {
      if (newMessage && token.value) {
        const params = {
          page: 1
        }
        await store.dispatch('users/fetchNotifications', params)
      }
    }, { immediate: true });

    onUnmounted(() => {
      disconnectSocket();
    });

    return { isLoading, calls, isMessage, isImport, token, removeCallAlert };
  }
}
</script>
<style scoped>
.access-denied-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
